import { GAME_ID, REDUX_ACTIONS, ONBOARDING_TYPES } from '../../data/constants';
import { getCuriosoMap, getCurriculum } from '../../content/curriculum/curriculumStorage';

const initialState = {
  selectedCell: { x: 0, y: 0 },
  curiososOnMap: [],
  isZoomedIn: false,
  isAnimatingZoom: false,
  levelIndex: 0,
  contentSide: 'sideA',
  isCameraBarDisabled: false,
  lastCuriosoEvent: 'none',
};

const mapReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX: {
      const curiososOnMap = lib.parseCuriosoMapJsonForLevel(payload.levelIndex, payload.contentSide);
      if (payload.onboardingType !== ONBOARDING_TYPES.NONE) {
        for (let i = 0; i < curiososOnMap.length; i++) {
          // remove all curiosos who are not specified as unique 'onboarding curiosos.'
          if (!curiososOnMap[i].isOnboardingItem) {
            curiososOnMap[i] = undefined;
          }
        }
      }

      return {
        ...state,
        curiososOnMap,
        isZoomedIn: initialState.isZoomedIn,
        isAnimatingZoom: initialState.isAnimatingZoom,
        levelIndex: payload.levelIndex,
        contentSide: payload.contentSide,
        isCameraBarDisabled: false,
      };
    }

    case REDUX_ACTIONS.RESTORE_MISSING_CURIOSOS: {
      const fullCuriosoList = lib.parseCuriosoMapJsonForLevel(state.levelIndex, state.contentSide);
      const { curiososOnMap } = state;

      for (let i = 0; i < curiososOnMap.length; i++) {
        if (curiososOnMap[i] === undefined) {
          curiososOnMap[i] = fullCuriosoList[i];
        }
      }

      return {
        ...state,
        curiososOnMap,
      };
    }

    case REDUX_ACTIONS.SET_IS_MAP_ZOOMED:
      return {
        ...state,
        isZoomedIn: payload,
      };

    case REDUX_ACTIONS.SET_IS_MAP_ANIMATING_ZOOM:
      return {
        ...state,
        isAnimatingZoom: payload,
      };

    case REDUX_ACTIONS.SET_SELECTED_MAP_CELL:
      return {
        ...state,
        selectedCell: payload.selectedCell,
        isCameraBarDisabled: false,
      };

    case REDUX_ACTIONS.SELECT_CURIOSO: {
      const { curiososOnMap } = state;
      curiososOnMap[payload % 5] = {
        ...curiososOnMap[payload % 5],
      };

      return {
        ...state,
        curiososOnMap,
      };
    }

    case REDUX_ACTIONS.SHIFT_CURIOSO_POSITION: {
      const curiososOnMap = state.curiososOnMap.map((element) => {
        if (element.curiosoIndex === payload) {
          return {
            ...element,
            currentLocationIndex: (element.currentLocationIndex + 1) % element.locations.length,
          };
        }
        return element;
      });

      return {
        ...state,
        curiososOnMap,
      };
    }

    case REDUX_ACTIONS.MAKE_CURIOSO_ESCAPE: {
      return {
        ...state,
        curiososOnMap: getCuriososOnMap(type, state.curiososOnMap, payload),
        isCameraBarDisabled: true,
        lastCuriosoEvent: 'escaped',
      };
    }

    case REDUX_ACTIONS.REVEAL_CURIOSO:
      return {
        ...state,
        curiososOnMap: getCuriososOnMap(type, state.curiososOnMap, payload),
        lastCuriosoEvent: 'revealed',
      };

    case REDUX_ACTIONS.HIDE_CURIOSO:
      return {
        ...state,
        curiososOnMap: getCuriososOnMap(type, state.curiososOnMap, payload),
      };

    case REDUX_ACTIONS.CANCEL_STANDARD_ITEM:
      return {
        ...state,
        lastCuriosoEvent: 'cancelled',
      };

    case REDUX_ACTIONS.QUICK_ROUND: {
      const curiososOnMap = state.curiososOnMap.map(element => ({
        ...element,
        isRevealed: payload.pass,
      }));
      return {
        ...state,
        curiososOnMap,
      };
    }

    default:
      return state;
  }
};

export default mapReducer;

const parseCuriosoMapJsonForLevel = (level, contentSide) => getCuriosoMap()[level].map((element, i) => ({
  ...element,
  currentContentIndex: contentSide === 'sideA' ? 0 : 1,
  currentLocationIndex: contentSide === 'sideA' ? 0 : 1,
  isRevealed: false,
  hasEscaped: false,
  isOnboardingItem: getCurriculum().content[level].items[i].isOnboardingItem,
}));

export const lib = {
  parseCuriosoMapJsonForLevel,
};

const getCuriososOnMap = (actionType, curiososOnMap, payload) =>
  curiososOnMap.map((element) => {
    if (element && element.curiosoIndex === payload) {
      return {
        ...element,
        isRevealed: actionType === REDUX_ACTIONS.REVEAL_CURIOSO,
        hasEscaped: actionType === REDUX_ACTIONS.MAKE_CURIOSO_ESCAPE,
      };
    }
    return element;
  });
